<template>
  <aside v-if="currentUserStore.isImpersonating" class="impersonation-status-drawer">
    <div class="card p-2 impersonation-status">
      <div class="small fw-bold text-uppercase mb-1">Impersonating Firebase UID</div>
      <div class="small mb-2">UID: <span class="fw-semibold">{{ currentUserStore.impersonated_uid }}</span></div>
      <RouterLink to="/admin/impersonate" class="btn btn-primary">Manage
      </RouterLink>
    </div>
  </aside>
</template>

<script>
import { mapStores } from "pinia";
import { useCurrentUserStore } from "@/common/stores/currentUserStore";

export default {
  name: "ImpersonationStatusComponent",
  computed: {
    ...mapStores(useCurrentUserStore),
  },
  mounted() {
    this.currentUserStore.initialize();
  },
};
</script>

<style scoped>
aside.impersonation-status-drawer {
  position: fixed;
  top: 0rem;
  left: 0rem;
  z-index: 1200;
  /* width: min(280px, calc(100vw - 1.5rem)); */
  transform: translate3d(calc(-100% + 2.5rem), calc(-100% + 2.5rem), 0);
  transition: transform 1000ms ease-in;
  padding: 0.75rem;
}

div.impersonation-status {
  /* width: min(280px, calc(100vw - 1.5rem)); */
  border: 4px solid var(--bs-orange);
  box-shadow: 8px 8px 24px var(--bs-orange);
  background: var(--bs-secondary);
  animation: impersonation-shadow-throb 3s ease-in-out infinite;
}

aside.impersonation-status-drawer:hover,
aside.impersonation-status-drawer:focus-within {
  transition-duration: 140ms;
  transition-timing-function: ease-out;
  transform: translate3d(0, 0, 0);
}

@media (hover: none) {
  aside.impersonation-status-drawer {
    transform: translate3d(0, 0, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  aside.impersonation-status-drawer {
    animation: none;
  }
}

@keyframes impersonation-shadow-throb {

  0%,
  100% {
    box-shadow: 8px 8px 16px color-mix(in srgb, var(--bs-orange) 65%, transparent);
  }

  50% {
    box-shadow: 10px 10px 28px color-mix(in srgb, var(--bs-orange) 95%, transparent);
  }
}
</style>
